import React from 'react';
import Images from '../assets/AllImages';
import { useTranslation } from 'react-i18next';

const INDOOR = () => {
  const { t } = useTranslation();

  return (
    <>
      <main>
        <div className="container-fluid bg-primary py-4">
          <div className="row align-items-center">
            <div className="col-12 col-md-6 px-5">
              <h1 className="text-white fw-bold mb-4 responsive-heading">
                {t("indoor.title")}
              </h1>
            </div>
            <div className="col-12 col-md-6 px-5 d-none d-sm-block text-end">
              <img src={Images.Vactor2} alt="Indoor Vector" className="vector-img" />
            </div>
          </div>
        </div>
      </main>

      {/* Indoor Banner Section */}
      <div
        className="container-fluid indoor-banner text-center text-white d-flex align-items-center justify-content-center"
        style={{ minHeight: '80vh' }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h4 className="lead responsive-subtitle">
                {t("indoor.bannerDesc")}
              </h4>
            </div>
          </div>
        </div>
      </div>

      {/* Facility Features Section */}
      <div className="container-fluid py-5">
        <div className="row align-items-center">
          <div className="col-lg-6 px-0">
            <img
              src={Images.Athelete}
              alt="Indoor Athlete Training"
              className="w-100"
              style={{ height: '600px', objectFit: 'cover' }}
            />
          </div>
          <div className="col-lg-6 p-5">
            <h3 className="text-primary fw-bold mb-4 responsive-heading">
              {t("indoor.features.title")}
            </h3>

            <div className="mb-4">
              <h5 className="text-primary fw-bold mb-2">
                {t("indoor.features.poolOlympic.title")}
              </h5>
              <p
                style={{
                  fontSize: '1.1rem',
                  lineHeight: '1.6',
                  color: '#666',
                  marginLeft: '1rem',
                }}
              >
                {t("indoor.features.poolOlympic.desc")}
              </p>
            </div>

            <div className="mb-4">
              <h5 className="text-primary fw-bold mb-2">
                {t("indoor.features.pool25.title")}
              </h5>
              <p
                style={{
                  fontSize: '1.1rem',
                  lineHeight: '1.6',
                  color: '#666',
                  marginLeft: '1rem',
                }}
              >
                {t("indoor.features.pool25.desc")}
              </p>
            </div>

            <div className="mb-4">
              <h5 className="text-primary fw-bold mb-2">
                {t("indoor.features.poolKids.title")}
              </h5>
              <p
                style={{
                  fontSize: '1.1rem',
                  lineHeight: '1.6',
                  color: '#666',
                  marginLeft: '1rem',
                }}
              >
                {t("indoor.features.poolKids.desc")}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Programs Section */}
      <div className="container-fluid py-5 bg-light">
        <div className="row align-items-center">
          <div className="col-lg-6 p-5">
            <h3 className="text-primary fw-bold mb-4 responsive-heading">
              {t("indoor.programs.title")}
            </h3>

            <ul
              className="list-unstyled mb-4"
              style={{ fontSize: '1.1rem', lineHeight: '1.8' }}
            >
              <li className="mb-3">
                <span className="text-primary fw-bold">
                  {t("indoor.programs.item1")}
                </span>
              </li>
              <li className="mb-3">
                <span className="text-primary fw-bold">
                  {t("indoor.programs.item2")}
                </span>
              </li>
              <li className="mb-3">
                <span className="text-primary fw-bold">
                  {t("indoor.programs.item3")}
                </span>
              </li>
              <li className="mb-3">
                <span className="text-primary fw-bold">
                  {t("indoor.programs.item4")}
                </span>
              </li>
            </ul>
          </div>
          <div className="col-lg-6 px-0">
            <img
              src={Images.SchoolGirl}
              alt="Swimming Programs"
              className="w-100"
              style={{ height: '500px', objectFit: 'cover' }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default INDOOR;
